<canvas #chart height="260"></canvas>